module.exports = __webpack_public_path__ + "media/SndCorrect.e0a5d01c.mp3";